export enum ModulesName {
  DASHBOARD = "Dashboard",
  LEAKED_PASSWORDS = "Leaked Passwords",
  ATTACK_SURFACE = "Attack Surface",
  DARK_WEB_EXPOSURE = "Dark Web Exposure",
  RECOMMENDATIONS = "Recommendations",
  PORTFOLIO_VIEW = "Portfolio View",
  ACCOUNT_SETTINGS = "Account Settings",
  API_RESOURCES = "API Resources",
  INTERNAL_ARCHITECTURE = "Internal Architecture",
  SECURITY_CHECKLIST = "Security Checklist",
}
